export function getSrIcon(sr, internal) {
  let sign = '<img src="../sign.svg" />';
  let csign = '<img src="../csign.svg" />';
  if (sr.reportedby == null) {
    return sign;
  }

  if (sr.type == "HOT" && !internal) {
    return sign;
  }

  return csign;
}

export function getSrStatusText(state) {
  switch (state) {
    case "CANCELLED":
      return "message.status.canceled";
    case "REJECTED":
      return "message.status.closed";
    case "RESOLVED":
      return "message.status.closed";
    case "NEW":
      return "message.status.new";
    case "PENDING":
      return "message.status.new";
    case "QUEUED":
      return "message.status.new";
    case "INPROG":
      return "message.status.sinprogress";
    case "CLOSED":
      return "message.status.closed";
    default:
      return "";
  }
}

export function getECM(ecm){
  if (
    [
      "MGW000",
      "MGWF",
      "MGWF-1",
      "MGWHU",
      "AKIEM SAS"
    ].includes(ecm.id)
  ) {
    return "AKIEM MAINTENANCE & SERVICES";
  } 
return ecm.name ;
}

export function mergeAffRanges(dateRanges) {
  if (!dateRanges || dateRanges.length === 0) return [];

  // Trier les plages par date de début (et par date de fin en cas d'égalité)
  dateRanges.sort((a, b) => a.startdate - b.startdate || a.enddate - b.enddate);

  const mergedRanges = [dateRanges[0]];

  for (let i = 1; i < dateRanges.length; i++) {
    let current = dateRanges[i]
    let currentStart = dateRanges[i].startdate;
    let currentEnd = dateRanges[i].endate;
    let lastStart = mergedRanges[mergedRanges.length - 1].startdate;
    let lastEnd = mergedRanges[mergedRanges.length - 1].enddate;

      // Si les plages se chevauchent ou sont adjacentes, fusionner
      if (currentStart <= lastEnd + 1) {
          mergedRanges[mergedRanges.length - 1] = {
              end: Math.max(lastEnd, currentEnd),
              start: lastStart,
              type: "background",
              group: current.asset,
              className: "aff" 
          }
      } else {
          // Sinon, ajouter la nouvelle plage au tableau fusionné
          mergedRanges.push(current);
      }
  }

  return mergedRanges;
}


export function getDocType(type){
  if(type == "LIVRAISON"){
    return "message.doc.certificat.delivry";
  }

  if(type == "RESTITUTION"){
    return "message.doc.certificat.redelivry";
  }

  return "UNKNOWN"
}

